module.exports = __webpack_public_path__ + "static/icons/icon-past--white-e325417a949344c09c4a7045811570cd.svg";